import { IsDevEnv } from '@/app'
import { testers } from '@/app/testers'

/** Dev builds prefill the tester account so nobody types credentials on every reload. */
export const initialState = IsDevEnv ? testers.default : undefined

/** At least eight characters, one capital, and one digit or symbol. */
export const passwordValidationRegex = /^(?=.*[A-Z])(?=.*[0-9!@#$%^&*]).{8,}/
